module.exports = __webpack_public_path__ + "images/no_contacts.94b3781d0d6f076249a0a2a17a4da570.png";